export default __webpack_public_path__ + "static/media/EnhancedCareatHomeSEHSCTv3.2220510SEHSCTEnhancedCareatHomereferralguidelinev3_2_flowchart.b6300311.jpg";